"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Version_1 = require("../version/Version");
const ApiVersionHeader_1 = tslib_1.__importDefault(require("./ApiVersionHeader"));
const ModuleRegistryFactory_1 = tslib_1.__importDefault(require("../module/ModuleRegistryFactory"));
const moment_1 = tslib_1.__importDefault(require("moment"));
class ApiVersionChecker {
    constructor(compiledVersion) {
        this.compiledVersion = compiledVersion;
    }
    send(request, next, prev) {
        next.send(request);
    }
    responseReceived(request, next, prev) {
        const moduleContext = ModuleRegistryFactory_1.default.getModuleContext();
        if (moduleContext) {
            const configuration = moduleContext.getConfiguration();
            const moduleConfiguration = moduleContext.getModuleConfiguration();
            // Note: This is before the module's config factory kicks in with its default values, hence the !== false check
            // below (we want api version checks enabled by default):
            if (configuration && configuration.isApiVersionCheckEnabled()
                && moduleConfiguration && moduleConfiguration.ApiVersionCheckEnabled !== false) {
                if (request.response && request.response.status !== 304) {
                    const apiVersion = request.response.headers.getHeader(ApiVersionHeader_1.default.NAME);
                    if (apiVersion) {
                        this.checkApiVersion(apiVersion);
                    }
                }
            }
        }
        prev.responseReceived(request);
    }
    checkApiVersion(versionHeader) {
        if (versionHeader) {
            const serverSideVersion = ApiVersionHeader_1.default.decode(versionHeader);
            if (serverSideVersion) {
                if (this.isApiVersionMismatch(serverSideVersion)) {
                    // Means that an inconsistency has been detected between the server and client side versions.
                    const confirm = window.confirm(`Der er detekteret en versionskonflikt, hvilket sandsynligvis skyldes at en ny version af FMK-online er idriftsat. Klik OK for at genstarte FMK-online (anbefales). Den igangværende handling vil blive afbrudt.

Din version: ${(0, Version_1.getVersionInfo)(this.compiledVersion)}
Server version: ${(0, Version_1.getVersionInfo)(serverSideVersion)}`);
                    if (confirm) {
                        // Restart application to get in sync - if our cache-control headers are correct, this will reload the client side.
                        ModuleRegistryFactory_1.default.getModuleContext().restartApplication();
                    }
                    else {
                        // Disable api version check for all modules, so that user is not prompted repeatedly
                        ModuleRegistryFactory_1.default.getInstance().getModuleContext().getConfiguration().disableApiVersionCheck();
                    }
                }
            }
        }
    }
    isApiVersionMismatch(serverVersion) {
        if (!serverVersion || !this.compiledVersion) {
            return false;
        }
        const serverPomVersion = serverVersion.getPomVersion();
        const compiledPomVersion = this.compiledVersion.getPomVersion();
        if (serverPomVersion && compiledPomVersion) {
            if (compiledPomVersion < serverPomVersion) {
                // Client version is older than server version
                return true;
            }
        }
        const serverBuildtime = serverVersion.getBuildtime();
        const compiledBuildtime = this.compiledVersion.getBuildtime();
        if (serverBuildtime && compiledBuildtime) {
            if ((0, moment_1.default)(compiledBuildtime).isBefore((0, moment_1.default)(serverBuildtime))) {
                // Client version is older than server version
                return true;
            }
        }
        return false;
    }
}
exports.default = ApiVersionChecker;
//# sourceMappingURL=ApiVersionChecker.js.map